export default __webpack_public_path__ + "static/media/laconic_medium.c3c34dbc.jpg";